import {createAction, props} from '@ngrx/store';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';
import {LandExtended} from '../../interfaces/land-extended.interface';


export class LandEntitiesActions {

  public static readLaender = createAction(
    '[Land Resolver] Read laender.',
    props<{
      betriebId: string,
    }>()
  );

  public static readLaenderSuccess = createAction(
    '[Land Entities] Read laender successfully.',
    props<{
      betriebId: string,
      landDtos: LandExtended[],
    }>()
  );

  public static readLaenderFailure = createAction(
    '[Land Entities] Read laender failed.',
    props<{
      error: MappedHttpErrorResponse,
    }>()
  );

  public static changeLaenderAutocomplete = createAction(
    '[Kunde Dialog] Change laender autocomplete.',
    props<{
      filter: string,
    }>()
  );

}
